/**
 * "Agoda-style" new tab:
 * the new tab opens on the CURRENT page first, then navigates to the
 * destination. Its history becomes [current page, destination], so the
 * browser Back button in the new tab returns to the page the user came from.
 *
 * Flow:
 *  1. Origin tab opens `currentUrl?__next=<destination>` in a new tab.
 *  2. `<NewTabHistoryRedirect />` (mounted in the root layout) sees `__next`,
 *     strips it from the URL (replaceState) and `router.push`es the destination.
 */

export const NEW_TAB_NEXT_PARAM = "__next";

/** Only allow same-origin relative paths (blocks open-redirects like `//evil.com`). */
export const isSafeInternalPath = (path: string | null): path is string =>
  Boolean(path && path.startsWith("/") && !path.startsWith("//"));

export const openInNewTabWithHistory = (destination: string) => {
  if (typeof window === "undefined") return;

  const origin = new URL(window.location.href);
  origin.searchParams.set(NEW_TAB_NEXT_PARAM, destination);

  window.open(
    `${origin.pathname}${origin.search}${origin.hash}`,
    "_blank",
    "noopener",
  );
};
